import React from "react";
import { Icon } from "@clarkinc/zest-design-system";
export default function BarcodeScannerFallback() {
  return <div className="fixed h-full w-full top-0 left-0 bg-black z-50 flex items-center justify-center" data-sentry-component="BarcodeScannerFallback" data-sentry-source-file="fallback.tsx">
      <div className="grid p-2 bg-white rounded">
        <Icon name="ri-loader-4-line" className="fill-green-100 col-start-1 row-start-1 w-12 h-12 animate-spin" data-sentry-element="Icon" data-sentry-source-file="fallback.tsx" />
        <Icon name="ri-loader-5-line" className="fill-green-700 col-start-1 row-start-1 w-12 h-12 animate-spin" data-sentry-element="Icon" data-sentry-source-file="fallback.tsx" />
      </div>
    </div>;
}